<template>
<div>
    <div class="allmiddle keyboardContainer">
        <el-input 
            :value="input"
            class="input"
            @input="onInputChange"
            show-password
            placeholder="请输入密码"
        >
        <el-button slot="append" type="danger" class="bt" @click="goNext">确 定</el-button> 
        </el-input>
        <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="input"/>        
    </div>
        <homeBtn @goHome="goHome" ref="homeBtn"></homeBtn>
        <backBtn @goBack="goBack" ref="backBtn"></backBtn> 
</div>
</template>

<script>
import SimpleKeyboard from "@/components/SimpleKeyboard";
import homeBtn from '@/components/homeButton'
import backBtn from '@/components/backButton'
export default {
    name: "inputName",
    components: {
        SimpleKeyboard,        
        homeBtn,
        backBtn
    },
    data() {
        return {
            input: "",            
            manageUrl: this.myStore.state.manageUrl,
            name:this.$route.query.name
        }
    },
    created () {
        
    },
    mounted () {

    },
    destroyed () {
        
    },
    methods: {
        onChange(input){
            this.input = input;
        },
        onKeyPress(button){
            console.log("button", button);
        },
        onInputChange(input){
            this.input = input.target.value;
        },
        goNext(){
            if(this.name=='000001'&& this.input=='111111'){
                this.$router.push({ path: this.manageUrl+'/home' }); 
            }else{
                this.$alert('', '账号密码错误', {
                    confirmButtonText: '确定',
                    type: 'error',
                    center: true
                });
            }
        },
        goBack(){
            this.$router.push({ path: this.manageUrl+'/inputName' }); 
        },
        goHome() {
            this.$router.push({ path: this.myStore.state.mainUrl });                
        }
    }
}
</script>

<style scoped>
    @import "~@/assets/css/buttons/buttons.css";
    .simple-keyboard {
        max-width: 60rem;
    }
    .keyboardContainer /deep/ .el-input-group__append{
        background: #409EFF;
        border: solid 1px #409EFF;
    }
    .keyboardContainer /deep/ .el-input__inner  {
        width: 100%;
        height: 5rem;
        padding: 10px;
        font-size: 35px;
        border: solid 8px #409EFF;
        box-sizing: border-box;
        text-align: center;
        letter-spacing: 5px;
        font-family: "Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
    .keyboardContainer {
        transition: margin-top 1s ease-in-out 0.5s, opacity 1s ease-in-out 0.5s, width 0.3s linear;
        overflow: hidden;
        width: 100%;
        z-index: 3;
        max-width: 850px;
        margin: 0 auto;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .keyboardContainer /deep/.hg-theme-default .hg-button{
        height: 3.3rem;
    }
    .keyboardContainer /deep/.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
        font-size: 1.8rem;
        color: white;
    }
</style>